export const ROUTES_RU = {
  HOME: 'Главная',
  EXPERIENCE: 'Опыт',
  SKILLS: 'Навыки',
  PROJECTS: 'Проекты',
  CONTACTS: 'Контакты',
};
